module.exports = __webpack_public_path__ + "img/logo.d5193723.svg";